// extracted by mini-css-extract-plugin
module.exports = {"administrationContainer":"Administration_administrationContainer__3DCmv","pageButton":"Administration_pageButton__2e0yy"};